import { getChain, SupportedChainId } from '~/constants/chains'
import { buildExplorerLink, ExplorerLinkType } from '~/utils/explorerLinks'

export const buildTenderlySimulationUrl = (simulationId: string) =>
  `https://www.tdly.co/shared/simulation/${simulationId}`

/**
 * Tenderly resolves user op hashes on the same /tx route as transactions, and
 * the user op page is the useful one for smart account transactions, so it
 * wins when present.
 */
export const getTxnDetailsUrl = ({
  chainId,
  txnHash,
  userOpHash,
}: {
  chainId: SupportedChainId
  txnHash: string
  userOpHash?: string | null
}) => {
  if (getChain(chainId)?.supportsTenderly)
    return `https://dashboard.tenderly.co/tx/${userOpHash || txnHash}`
  return buildExplorerLink({
    chainId,
    type: ExplorerLinkType.TRANSACTION,
    txHash: txnHash,
  })
}
